import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import MobileDatePicker from "commons/ui/input/MobileDatePicker";
import Select from "commons/ui/input/Select";
import SwitchInput from "commons/ui/input/SwitchInput";
import WysiwygSimpleEditor from "commons/ui/input/WysiwygSimpleEditor";
import Paper from "commons/ui/Paper";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import MetaFieldsForm from "components/subComponents/MetaFieldsForm";
import OrderableImages from "components/subComponents/OrderableImages";
import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import AttachmentPicker from "components/ui/AttachmentPicker";

import useNewsForm from "hooks/form/useNewsForm";

import { DesktopOrMobile, NewsMediaEnum } from "types/enums";

function NewsForm() {
    const { setDesktopMobileImage, orderableImagesHook, datePickerHookFrom, formHook } =
        useNewsForm();

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridColumn>
            <Paper>
                <GridColumn>
                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Impostazioni</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-5"}>
                            <MobileDatePicker datePickerHook={datePickerHookFrom} />
                        </GridItem>

                        <GridItem className={"col-xs-12-6"}>
                            <InputText
                                label={"Slug"}
                                value={form.slug}
                                setValue={setValue}
                                path={"slug"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-1"}>
                            <SwitchInput
                                checked={form.enabled}
                                label={"Area pubblica"}
                                setValue={setValue}
                                path={"enabled"}
                                alignedToForm
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className="title-margin">
                        <GridItem>
                            <h2>Thumbnail</h2>
                        </GridItem>
                    </GridRow>

                    <ExtensionsProporsionInfo
                        desktopText={"Desktop: 600x338px (max 60KB)"}
                        mobileText={"Mobile: 400x225px (max 50KB)"}
                        proportion={"16:9"}
                    />

                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <AttachmentPicker
                                buttonLabel={"Foto Desktop"}
                                setFile={(file) =>
                                    setDesktopMobileImage(file, DesktopOrMobile.desktop)
                                }
                                file={form.cover_img.desktop}
                                accept={".png,.jpg,.jpeg"}
                                errors={checkErrorVisibility("cover_img.desktop")}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-6"}>
                            <AttachmentPicker
                                buttonLabel={"Foto Mobile"}
                                setFile={(file) =>
                                    setDesktopMobileImage(file, DesktopOrMobile.mobile)
                                }
                                file={form.cover_img.mobile}
                                accept={".png,.jpg,.jpeg"}
                                errors={checkErrorVisibility("cover_img.mobile")}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Testo Italiano</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                label={"Titolo"}
                                startAdornment={TwoLanguagesAdornment("it")}
                                setValue={setValue}
                                value={form.text.it.title}
                                path={"text.it.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <WysiwygSimpleEditor
                                label={"Descrizione"}
                                bigDefault={true}
                                value={form.text.it.description}
                                path={"text.it.description"}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className="title-margin">
                        <GridItem>
                            <h2>Testo Inglese</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                label={"Titolo"}
                                startAdornment={TwoLanguagesAdornment("en")}
                                setValue={setValue}
                                value={form.text.en.title}
                                path={"text.en.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <WysiwygSimpleEditor
                                label={"Descrizione"}
                                bigDefault={true}
                                value={form.text.en.description}
                                path={"text.en.description"}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <MetaFieldsForm
                        text={form.text}
                        setValue={setValue}
                        checkErrorVisibility={checkErrorVisibility}
                    />

                    <GridRow>
                        <GridItem className={"title-margin"}>
                            <h2>Immagini / Video </h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <Select
                                label={"Tipologia"}
                                options={[
                                    { value: NewsMediaEnum.gallery, label: "Galleria" },
                                    { value: NewsMediaEnum.video, label: "Video" },
                                ]}
                                value={form.media}
                                setValue={setValue}
                                path={"media"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    {form.media === NewsMediaEnum.video && (
                        <GridRow>
                            <GridItem className={"col-xs-12-6"}>
                                <InputText
                                    label={"Url del video"}
                                    value={form.url_video}
                                    setValue={setValue}
                                    path={"url_video"}
                                    checkErrorVisibility={checkErrorVisibility}
                                />
                            </GridItem>
                        </GridRow>
                    )}

                    {form.media === NewsMediaEnum.gallery && (
                        <ExtensionsProporsionInfo proportion={"16:9"} />
                    )}
                </GridColumn>

                {form.media === NewsMediaEnum.gallery && (
                    <OrderableImages orderableImagesHook={orderableImagesHook} />
                )}
            </Paper>
        </GridColumn>
    );
}

export default NewsForm;
